import React, { useEffect, useState } from 'react';

export const MobileDebug: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="fixed bottom-4 right-4 bg-black text-white p-3 rounded-lg shadow-lg z-50 text-xs">
      <div>Width: {windowWidth}px</div>
      <div>Mobile: {isMobile ? 'Yes' : 'No'}</div>
      <div className="md:hidden">Tailwind: Mobile</div>
      <div className="hidden md:block">Tailwind: Desktop</div>
    </div>
  );
};